<template>
  <div>
    <card class="header" :class="'card-catalog-'+theme">
      <div >
        <h4 class="card-title">Dados de Usuário</h4>
      </div>
      <hr />
      <div>
        <div
          class="row"
          v-if="loadingStudent"
          v-loading="loadingStudent"
          id="loading"
        >
        </div>
        <form v-if="!loadingStudent">
          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="email"
                label="E-mail:"
                :disabled="true"
                placeholder="seuemail@email.com"
                v-model="userProfile.email"
              >
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Nome:"
                placeholder="Primeiro Nome"
                v-model="userProfile.name"
              >
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Sobrenome"
                placeholder="Sobrenome"
                v-model="userProfile.surname"
              >
              </fg-input>
            </div>
          </div>
          <div class="text-right">
            <button class="btn btn-round btn-fill"
            :class=" theme === 'black' ? 'btn-azure2':'btn-primary' " type="submit" @click.prevent="submitUserProfileUpdate()">
              Salvar Alterações
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>

    <card :class="'card-catalog-'+theme">
      <div class="header">
        <h4 class="card-title">Dados Pessoais</h4>
      </div>
      <hr />
      <div>
        <div
          class="row"
          v-if="loadingStudent"
          v-loading="loadingStudent"
          id="loading"
        >
        </div>
        <form v-if="!loadingStudent">
          <div class="row">
            <div class="col-md-5">
              <fg-input
                type="text"
                label="CPF: "
                required
                placeholder="Somente Números"
                maxlength="11"
                v-model="studentProfile.cpf"
              >
              </fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="text"
                required
                label="Data de Nascimento: "
                v-mask="'##/##/####'"
                maxlength="10"
                v-model="studentProfile.birthdate"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <label>Sexo:*</label>
              </br>
              <el-select
                class="col-md-12 select-" :class="theme === 'black' ? 'azure' : 'primary'"
                size="large"
                required
                placeholder="Selecione Aqui..."
                v-model="studentProfile.gender"
                >
                <el-option
                  v-for="option in selects.genders"
                  class="select-warning"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label>Profissão: *</label>
              <br />
              <el-select class="col-md-12 select-" required
                :class=" theme === 'black' ? 'azure':'primary' " size="large" placeholder="Selecione Aqui..." v-model="studentProfile.job">
                <el-option v-for="option in jobs" class="select-warning" :value="option" :label="option" :key="option"></el-option>
              </el-select>
            </div>
            <div class="col-md-6">
              <fg-input
                type="text"
                required
                label="CEP:"
                placeholder="CEP - Somente Números"
                maxlength="8"
                v-model="studentProfile.cep"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-5">
              <fg-input
                type="text"
                required
                label="Endereço:"
                placeholder="Av. Endereço."
                v-model="studentProfile.address"
              >
              </fg-input>
            </div>
            <div class="col-md-2">
              <fg-input
                type="text"
                label="Número:"
                required
                placeholder="####"
                v-model="studentProfile.address_number"
              >
              </fg-input>
            </div>
            <div class="col-md-5">
              <fg-input
                type="text"
                label="Complemento:"
                placeholder="Complemento."
                v-model="studentProfile.address_complement"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <label>Estado: *</label>
              </br>
              <el-select required :class=" theme === 'black' ? 'azure':'primary' " size="large" placeholder="Selecione Aqui..." v-model="studentProfile.state" @change="setStateIndex()">
                <el-option v-for="(option, index) in states" class="select-warning" :value="option.nome" :label="option.nome" :key="option.sigla">
                </el-option>
              </el-select>
            </div>
            <div class="col-md-4">
              <label>Cidade: *</label>
              </br>
              <el-select required :class=" theme === 'black' ? 'azure':'primary' " size="large" placeholder="Selecione Aqui..." v-model="studentProfile.city">
                <el-option v-for="(option) in states[stateIndex].cidades" class="select-warning" :value="option" :label="option" :key="option">
                </el-option>
              </el-select>
            </div>
            <div class="col-md-4">
              <label>País*:</label>
              </br>
               <el-select required :class=" theme === 'black' ? 'azure':'primary' " size="large" placeholder="Selecione Aqui..." v-model="studentProfile.country">
                <el-option v-for="(option) in countries" class="select-warning" :value="option.nome" :label="option.nome" :key="option.ordem">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <label>Reside fora do Brasil ?*</label>
              </br>
               <el-select required :class=" theme === 'black' ? 'azure':'primary' " size="large" placeholder="Selecione Aqui..." v-model="studentProfile.is_foreign_country">
                <el-option v-for="option in selects.isForeignCountry" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
              </el-select>

            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                class="col-md-10"
                label="Telefone-Celular (Whatsapp):"
                placeholder="Somente Números"
                maxlength="11"
                required
                v-model="studentProfile.cellphone"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                class="col-md-10"
                label="Link Facebook:"
                placeholder="https://www.facebook.com/xxxx"
                v-model="studentProfile.facebook_link"
              >
              </fg-input>
            </div>
          </div>
          <div class="text-center">
            <button
              class="btn btn-azure btn-round"
              v-if="theme === 'black'" type="submit"
              @click.prevent="submitStudentProfileUpdate()">Salvar Alterações
            </button>
            <button class="btn btn-info btn-fill btn-wd pull-right"
              v-if="theme === 'light'" type="submit"
              @click.prevent="submitStudentProfileUpdate()">Salvar Alterações
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
        <small>* Os campos são obrigatórios</small>
      </div>
    </card>

    <card :class="'card-catalog-'+theme">
      <div class="header">
        <h4 class="card-title">Dados de Segurança</h4>
      </div>
      <hr />
      <div>
        <div
          class="row"
          v-if="loadingStudent"
          v-loading="loadingStudent"
          id="loading"
        >
        </div>
        <form v-if="!loadingStudent">
          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="password"
                label="Nova Senha:"
                placeholder="Deve conter no mínimo 6 dígitos"
                v-model="userPassword.password"
              >
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
                type="password"
                label="Confirmar Nova Senha:"
                placeholder="Repita nova senha"
                v-model="userPassword.password_confirmation"
              >
              </fg-input>
            </div>
          </div>
          <div class="text-right">
            <button class="btn btn-round"
              :class=" theme === 'black' ? 'btn-azure':'btn-primary' "
              :disabled="!(userPassword.password&&userPassword.password_confirmation)"
              type="submit" @click.prevent="submitStudentPasswordUpdate()">
               Salvar Nova Senha
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import Vue from 'vue'
import swal from 'sweetalert2'
import { Loading, Select, Dialog, Option } from 'element-ui'
import { mask } from 'vue-the-mask'
import moment from 'moment-timezone'

// Utilities
import { BrazilianStates } from 'src//utils/modals/brazilian-states'
import { Countries } from 'src/utils/modals/countries'
import { Jobs } from 'src/utils/modals/jobs'

Vue.use(Loading.directive)
moment.tz.setDefault('America/Sao_Paulo')
Vue.use(require('vue-moment'))

export default {
  components: {
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Option.name]: Option
  },
  directives: { mask },
  data () {
    return {
      loadingStudent: false,
      userPassword: {
        password: '',
        password_confirmation: ''
      },
      userProfile: {
        name: '',
        surname: '',
        email: ''
      },
      studentProfile: {
        gender: '',
        job: '',
        cpf: '',
        birthdate: '',
        cellphone: '',
        cep: '',
        address: '',
        address_complement: '',
        address_number: '',
        city: '',
        state: '',
        country: '',
        is_foreign_country: '',
        facebook_link: ''
      },
      formErrors: [],
      selects: {
        genders: [
          { value: 'M', label: 'Masculino' },
          { value: 'F', label: 'Feminino' },
          { value: 'N', label: 'Prefiro não Informar' }
        ],
        isForeignCountry: [
          { value: 1, label: 'Sim' },
          { value: 0, label: 'Não' }
        ]
      },
      modals: {
        newSubscription: false,
        creditCardUpdate: false,
        cancel: false,
        reactivate: false
      },
      jobs: Jobs,
      countries: Countries,
      states: BrazilianStates.estados,
      stateIndex: 0
    }
  },
  methods: {
    notifyVue (message, verticalAlign, horizontalAlign, color, icon) {
      this.$notify(
        {
          component: {
            template: `<h5 class="card-title">${message}</h5>`
          },
          icon: 'nc-icon ' + icon,
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type: color
        })
    },
    fetchUser () {
      this.$auth.fetch({
        params: {},
        success: function () {
          this.userProfile.name = this.$auth.user().name
          this.userProfile.surname = this.$auth.user().surname
          this.userProfile.email = this.$auth.user().email
        },
        error: function (error) {
          console.log(error)
          alert('Erro ao recarregar usuário. Tente novamente \n. ' + error)
        }
      })
    },
    fetchStudent () {
      this.loadingStudent = true
      this.axios
        .get('/student/' + this.$auth.user().userable_id)
        .then(response => {
          this.loadingStudent = false
          if (response.data.data) {
            this.studentProfile = response.data.data
          }
        })
        .catch(error => {
          this.loadingStudent = false
          console.log(error)
          alert('Erro ao carregar dados do aluno. Tente novamente \n. ' + error)
        })
    },
    submitUserProfileUpdate () {
      this.loadingStudent = true
      this.axios
        .patch('/student/userupdate', this.userProfile)
        .then(response => {
          this.loadingStudent = false
          this.notifyVue('Dados de Usuário alterados com sucesso', 'top', 'center', 'primary', 'nc-check-2')
          this.fetchUser()
        })
        .catch(error => {
          this.loadingStudent = false
          console.log(error)
          alert('Erro ao salvar dados de usuário. Tente novamente \n. ' + error)
        })
    },
    submitStudentProfileUpdate () {
      this.loadingStudent = true
      this.axios
        .patch('/student/infoupdate', this.studentProfile)
        .then(response => {
          this.loadingStudent = false
          this.notifyVue('Dados Pessoais alterados com sucesso', 'top', 'center', 'primary', 'nc-check-2')
        })
        .catch(error => {
          this.loadingStudent = false
          console.log(error)
          alert('Erro ao salvar alterações. Verifique se todos os campos foram preenchidos com informações válidas')
        })
    },
    submitStudentPasswordUpdate () {
      this.loadingStudent = true
      this.axios
        .patch('/student/userpwdupdate', this.userPassword)
        .then(response => {
          this.loadingStudent = false
          this.notifyVue('Senha Alterada com sucesso', 'top', 'center', 'primary', 'nc-check-2')
          this.userPassword.password = ''
          this.userPassword.password_confirmation = ''
        })
        .catch(error => {
          this.loadingStudent = false
          this.userPassword.password = ''
          this.userPassword.password_confirmation = ''
          console.log(error)
          alert('Erro ao alterar senha. Certifique-se que as senhas possuem ao menos 6 caracteres e são iguais: ' + error)
        })
    },

    setStateIndex () {
      let index = 0
      this.studentProfile.city = ''
      for (let state of this.states) {
        if (state.nome === this.studentProfile.state) {
          this.stateIndex = index
        }
        index++
      }
    },
    openModal (name) {
      this.modals[name] = true
    },
    closeModal (name) {
      this.modals[name] = false
    },
    showSwal (title, message, buttonClass, type) {
      swal({
        title: title,
        text: message,
        confirmButtonClass: buttonClass,
        type: type
      })
    },
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  },
  created () {
    this.fetchUser()
    this.fetchStudent()
  }
}

</script>
<style>
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
  .el-loading-spinner .path {
    stroke: #000 !important;
  }

  .el-loading-mask {
    background: transparent !important;
  }
}

.el-dialog {
  width: 50%;
}
@media (max-width: 800px) {
  .el-dialog {
    width: 90%;
  }
}

input#the-card-name-id {
  text-transform: uppercase;
}
input {
  background-color: #f7f7f7 !important;
  color: #3e3e3e!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/UserProfile/EditProfileForm.vue